var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockQuote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.497 7v7c.017 2.557-1.985 4.714-4.64 5-.148.019-.297-.025-.408-.12-.12-.104-.186-.255-.178-.41v-2c.009-.227.176-.42.408-.47.993-.189 1.702-1.031 1.683-2v-1H5.226c-1.154 0-2.09-.895-2.09-2V7c0-1.105.936-2 2.09-2h4.18c1.155 0 2.091.895 2.091 2zm8.362-2h-4.18c-1.155 0-2.091.895-2.091 2v4c0 1.105.936 2 2.09 2h3.136v1c.02.969-.69 1.811-1.683 2-.24.052-.409.255-.408.49v2c.002.145.066.283.178.38.111.095.26.139.408.12 2.651-.286 4.652-2.437 4.64-4.99V7c0-1.105-.936-2-2.09-2z",
    transform: "translate(-879 -1240) translate(303 665) translate(24 562) translate(552.914 13)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockQuote);
export default __webpack_public_path__ + "static/media/blockQuote.cdb5d7539c17711ae9ec4e6ca3d98ed8.svg";
export { ForwardRef as ReactComponent };